<template>
  <div class="tbr-form">
    <div class="tbr-header">
      <span class="tbr-heading">Want Updates from</span>
      <span class="tbr-heading-title">The Bible Recap?</span>
    </div>
    <form ref="TBRProfileForm" name="TBRProfileForm" action="https://media.bakerbookhouse.com/u/register.php" method="get">
      <input type="hidden" name="CID" value="1091360261">
      <input type="hidden" name="SID" :value="SID">
      <input type="hidden" name="UID" :value="UID">
      <input type="hidden" name="f" value="601">
      <input type="hidden" name="p" value="2">
      <input type="hidden" name="a" value="r">
      <input type="hidden" name="el" :value="el">
      <input type="hidden" name="llid" :value="llid">
      <input type="hidden" name="c" :value="c">
      <input type="hidden" name="counted" :value="counted">
      <input type="hidden" name="RID" :value="RID">
      <input type="hidden" name="mailnow" :value="mailnow">
      <input type="hidden" name="inp_11850" value="TRUE">
      <input type="hidden" name="inp_11851" value="TRUE">
      <input type="hidden" name="interest_tlc" value="TRUE">
      <input type="hidden" name="interest_tbr" value="TRUE">
      <div class="form-entry">
        <div class="form-label">
First Name:
</div>
        <div class="form-input">
          <input v-model="inp_1" name="inp_1" type="text" maxlength="60">
        </div>
      </div>

      <div class="form-entry">
        <div class="form-label">
Last Name:
</div>
        <div class="form-input">
          <input v-model="inp_2" name="inp_2" type="text" maxlength="60">
        </div>
      </div>

      <div class="form-entry">
        <div class="form-label">
Email:
</div>
        <div class="form-input">
          <input v-model="inp_3" name="inp_3" type="email" maxlength="255">
        </div>
      </div>

      <div class="form-entry full-width">
        <label class="form-optin">
          <input v-model="optin" name="optin" type="checkbox" value="y">
          I opt-in to receive marketing emails from Baker Book House.
        </label>
      </div>
      <div class="form-entry full-width">
        <input
          aria-label="Submit"
          tabindex="993"
          type="button"
          name="submit1"
          value="Submit"
          @click="SubmitIt"
          >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'TbrForm',
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      SID: '',
      UID: '',
      el: '',
      llid: '',
      c: '',
      counted: '',
      RID: '',
      mailnow: '',
      inp_1: '',
      inp_2: '',
      inp_3: '',
      optin: 'y',
      error: ''
    }
  },
  methods: {
    isValid () {
      let error = ''
      if (!this.inp_1) { error += 'First Name: missing data!\n' }
      if (!this.inp_2) { error += 'Last Name: missing data!\n' }
      if (!this.inp_3) { error += 'Email: missing data!\n' }

      this.error = error
      if (error) {
        alert(error)
        return false
      }
      return true
    },
    SubmitIt () {
      if (this.isValid()) {
        this.$refs.TBRProfileForm.submit()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.tbr-form {
  padding: 2em;
  width: 50%;
  max-width: 500px;
  margin: 0 auto;

  .tbr-header {
    background-color: #043d68;
    color: white;

    .tbr-heading {
      font-size: 2em;
      font-weight: bold;
      display: block;
      text-align: center;
    }

    .tbr-heading-title {
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 2em;
      display: block;
      text-align: center;
      font-style: italic;
    }
  }
}

.form-entry {
  display: flex;
  align-items: center;
  margin-bottom: 1em;
  font-size: 2em;

  .form-label {
    width: 30%;
    font-weight: bold;
    padding-right: 1em;
    text-align: left;
  }

  .form-input {
    width: 70%;
  }

  .form-optin {
    font-size: 0.8em;
    font-weight: lighter;
    display: flex;
    align-items: center;
  }

  input[type="text"],
  input[type="email"] {
    width: 100%;
    padding: 0.5em;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  &.full-width {
    display: block;
    text-align: center;

    label {
      font-weight: normal;
    }

    input[type="button"] {
      margin-top: 1em;
    }
  }
}

input[type="button"] {
  background-color: #043d68;
  color: white;
  padding: 0.5em 1.5em;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #032a4d;
  }
}

.form-elements {
  display: none;
}

/* ======= Mobile responsive adjustments ======= */
@media (max-width: 600px) {
  .form-entry {
    flex-direction: column;
    align-items: flex-start;
    font-size: 1.5em;

    .form-label,
    .form-input {
      width: 100%;
      padding: 0;
      text-align: left;
    }

    .form-label {
      margin-bottom: 0.5em;
    }
  }

  .tbr-form {
    width: 90%;
    padding: 1em;
  }
}
</style>
